var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sync-failed-contacts-page"}},[_c('datatable',{ref:"dtComponent",attrs:{"modelData":_vm.dtData,"inline-edit":true},on:{"editItem":function($event){return _vm.updateContact($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }